import { useIntl } from "react-intl";

import ImageChecklistSide, {
    ListItemWithEmphsis
} from "../../../../../../../../patterns/image-checklist-side";

const SoftwareTeams = () => {
    const intl = useIntl();

    const title = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.headerText",
        defaultMessage: "Software teams"
    });

    const agileBoards = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.agileBoards.strongtext",
            defaultMessage: "Powerful agile boards:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.agileBoards.plainText",
            defaultMessage:
                " Scrum and Kanban boards help agile teams break large, complex projects into manageable pieces of work so focused teams, working in sprints, ship faster."
        })
    };

    const timeline = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.timeline.strongtext",
            defaultMessage: "Timeline:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.timeline.plainText",
            defaultMessage:
                " Keep your teams and organization in sync with project timelines. Give teams the context needed to make quick decisions while staying aligned with the bigger goals."
        })
    };

    const reportAndInsights = {
        strongText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.reportAndInsights.strongtext",
            defaultMessage: "Reports and insights:"
        }),
        plainText: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.reportAndInsights.plainText",
            defaultMessage:
                " Out-of-the-box reports and dashboards in Jira Software offer critical insights within the context of your work to ensure your teams are always up to date and set up for success."
        })
    };

    const listItems = [
        ListItemWithEmphsis(agileBoards),
        ListItemWithEmphsis(timeline),
        ListItemWithEmphsis(reportAndInsights)
    ];
    const imageSrc =
        "https://wac-cdn.atlassian.com/dam/jcr:ccc1d490-ea86-4583-8550-6a1cbe2fb2f9/SOFTWARE%20TEAMS@2x.png?cdnVersion=ece";
    const imageAlt = intl.formatMessage({
        id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.tabsImageAltText",
        defaultMessage: "software teams"
    });

    const testimony = {
        isIncludeTestimony: true,
        quoteBlurb: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.testimony.quoteBlurb",
            defaultMessage:
                "The agility of the teams across Canva has increased because of Jira, especially as we’re scaling up."
        }),
        quoteName: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.testimony.quoteName",
            defaultMessage: "JEFF LAI"
        }),
        quoteCompany: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.testimony.quoteCompany",
            defaultMessage: "INTERNAL INFRASTRUCTURE, CANVA"
        }),
        testimonyImageClassName: "tab-testimony-image",
        testimonyImageSrc:
            "https://wac-cdn.atlassian.com/dam/jcr:122314d2-09a1-4f45-97dc-85da2080600f/LP-logos_canva%20logo.svg?cdnVersion=ece",
        testimonyImageAlt: intl.formatMessage({
            id: "JiraSoftwarePage.PaidLpJswPm.softwareTeams.testimony.logo.imageAltText",
            defaultMessage: "Canva logo"
        })
    };

    return (
        <ImageChecklistSide
            title={title}
            listItems={listItems}
            imageSrc={imageSrc}
            imageAlt={imageAlt}
            isIncludeTestimony={testimony.isIncludeTestimony}
            quoteBlurb={testimony.quoteBlurb}
            quoteName={testimony.quoteName}
            quoteCompany={testimony.quoteCompany}
            testimonyImageClassName={testimony.testimonyImageClassName}
            testimonyImageSrc={testimony.testimonyImageSrc}
            testimonyImageAlt={testimony.testimonyImageAlt}
        />
    );
};

export default SoftwareTeams;
